import React, { useEffect, createElement } from 'react';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { BigIdea } from './components/sections/BigIdea';
import { Keys } from './components/sections/Keys';
import { MidCTA } from './components/sections/MidCTA';
import { Transformation } from './components/sections/Transformation';
import { Preview } from './components/sections/Preview';
import { WhoFor } from './components/sections/WhoFor';
import { WhyDifferent } from './components/sections/WhyDifferent';
import { Author } from './components/sections/Author';
import { ValueStack } from './components/sections/ValueStack';
import { Journey } from './components/sections/Journey';
import { FAQ } from './components/sections/FAQ';
import { Disclaimer } from './components/sections/Disclaimer';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { StickyCTA } from './components/StickyCTA';
import { SectionBridge } from './components/SectionBridge';
export function App() {
  useEffect(() => {
    document.title = 'La Estabilidad Dimensional de Nuestro Ser | Daniel Navarro';
    const metas: {
      name?: string;
      property?: string;
      content: string;
    }[] = [{
      name: 'description',
      content: 'Descubre el libro digital de Daniel Navarro sobre equilibrio interior, vitalidad, emociones, disciplina, intuición, propósito y plenitud. Una guía de diez claves para armonizar las dimensiones de tu ser.'
    }, {
      name: 'keywords',
      content: 'libro de crecimiento personal en español, equilibrio interior, plenitud, Daniel Navarro, estabilidad dimensional, intuición, propósito, disciplina, bienestar emocional, desarrollo personal'
    }, {
      property: 'og:title',
      content: 'La Estabilidad Dimensional de Nuestro Ser | Daniel Navarro'
    }, {
      property: 'og:description',
      content: 'Diez claves para lograr el equilibrio y la plenitud. Una guía profunda para armonizar cuerpo, mente, emociones, intuición y propósito.'
    }, {
      property: 'og:type',
      content: 'book'
    }];
    metas.forEach(m => {
      const sel = m.name ? `meta[name="${m.name}"]` : `meta[property="${m.property}"]`;
      let el = document.querySelector(sel) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        if (m.name) el.setAttribute('name', m.name);
        if (m.property) el.setAttribute('property', m.property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', m.content);
    });
  }, []);
  return <main className="bg-navy-deep text-ivory min-h-screen w-full overflow-x-hidden" data-id="element-0">
      {/* Act 1 — Chaos / cosmic darkness */}
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <SectionBridge variant="deep-mid" height="h-24 lg:h-32" data-id="element-3" />
      <BigIdea data-id="element-4" />

      {/* Act 2 — Dawn / gold warming up */}
      <SectionBridge variant="mid-deep" height="h-24 lg:h-32" data-id="element-5" />
      <Keys data-id="element-6" />
      <MidCTA data-id="element-7" />
      <SectionBridge variant="deep-mid" height="h-20 lg:h-28" data-id="element-8" />
      <Transformation data-id="element-9" />
      <SectionBridge variant="mid-deep" height="h-20 lg:h-28" data-id="element-10" />
      <Preview data-id="element-11" />

      {/* Sunrise — ivory contrast moment */}
      <SectionBridge variant="navy-ivory" height="h-32 lg:h-48" data-id="element-12" />
      <WhoFor data-id="element-13" />
      <SectionBridge variant="ivory-navy" height="h-32 lg:h-48" data-id="element-14" />

      {/* Act 3 — Harmony / golden hour */}
      <WhyDifferent data-id="element-15" />
      <SectionBridge variant="deep-mid" height="h-20 lg:h-28" data-id="element-16" />
      <Author data-id="element-17" />
      <SectionBridge variant="mid-deep" height="h-20 lg:h-28" data-id="element-18" />
      <ValueStack data-id="element-19" />
      <SectionBridge variant="deep-mid" height="h-20 lg:h-28" data-id="element-20" />
      <Journey data-id="element-21" />
      <SectionBridge variant="mid-deep" height="h-20 lg:h-28" data-id="element-22" />
      <FAQ data-id="element-23" />
      <Disclaimer data-id="element-24" />
      <FinalCTA data-id="element-25" />
      <Footer data-id="element-26" />
      <StickyCTA data-id="element-27" />
    </main>;
}